module.exports = __webpack_public_path__ + "img/testSceneSel.3d9a8ce3.png";